import { PaymentCard } from "@features/payments";
import { Container, Typography } from "@mui/material";
import React from "react";
// extend({ OrbitControls });
interface PaymentProps {}

const Payment: React.FC<PaymentProps> = () => (
    <>
        <Container disableGutters maxWidth="sm" component="main" sx={{ pb: 6 }}>
            <Typography variant="h3" align="center" color="text.primary" component="h3">
                Products
            </Typography>
        </Container>
        <PaymentCard />
    </>
);

export default Payment;
